import React from 'react';
import styled, { keyframes } from 'styled-components';
import {TITLE_FONT_COLOR,TERTIARY_FONT_COLOR} from 'src/styles/fonts/MCFontConstants.js';


const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const Spinner = styled.div`
  width: 25px;
  height: 25px;
  border: 4px solid ${TERTIARY_FONT_COLOR};
  border-top: 4px solid ${TITLE_FONT_COLOR};
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
  margin: auto;
`;

const LoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  //height: 100vh;
`;

const Loader = () => (
  <LoaderWrapper>
    <Spinner />
  </LoaderWrapper>
);

export default Loader;